import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellCurrency } from '../../table/cells/CellCurrency';

export const ModelCellCurrencyBase = (props: TableInheritedProps) => (
  <CellCurrency {...props} />
);

export const ModelCellCurrency = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellCurrency',
    ModelCellCurrencyBase,
    props
  );
